import { ENABLE_DEBUG_LOGS } from '../config/economyConfig';

export const debugLog = (...args) => {
    if (ENABLE_DEBUG_LOGS) {
        console.log(...args);
    }
};

export const logInfo = debugLog;

export const logWarn = (...args) => {
    console.warn(...args);
};

export const logError = (...args) => {
    console.error(...args);
};
